import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./layout/header";
import Footer from "./layout/footer";
import Login from "./components/login";
import ProductsList from "./components/list";
import Products from "./components/products";
import UserList from "./components/user";
import UserView from "./components/user_view";
import UserEdit from "./components/user_edit";
import GiftList from "./components/gift";
import AddGift from "./components/add_gift";
import GreetingList from "./components/greeting";
import AddGreetingCard from "./components/add_greeting";
import Category from "./components/category";
import AddCategory from "./components/add_category";
import Ordermanagement from "./components/ordermanagement";
import Ordermanagementview from "./components/ordermanagement_view";
import Signup from "./components/signup";
import BusinessList from "./components/business";
const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    const isAuthenticated = checkUserAuthentication();
    setIsLoggedIn(isAuthenticated);
  }, []);

  // Function to check authentication
  const checkUserAuthentication = () => {
    const token = window.localStorage.getItem("user_id");
    return !!token; // Returns true if token exists, otherwise false
  };

  // If authentication state is still loading, render a loading state or nothing
  if (isLoggedIn === null) {
    return <div>Loading...</div>; // You can replace this with a spinner or something else
  }

  return (
    <BrowserRouter>
      <BodyClassManager isLoggedIn={isLoggedIn} />
      <Routes>
        {/* <Route path="/signup" element={!isLoggedIn ? <Signup setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/ordermanagement" />} /> */}

        <Route path="/list" element={isLoggedIn ? <Ordermanagementview /> : <Navigate to="/login" />} />
        <Route path="/products" element={<Products />} />

        <Route path="/login" element={!isLoggedIn ? <Login setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/businesses" />} />


        <Route path="/" element={isLoggedIn ? <BusinessList /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/users" element={isLoggedIn ? <UserList /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/user_view" element={isLoggedIn ? <UserView /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/user_edit" element={isLoggedIn ? <UserEdit /> : <Login setIsLoggedIn={setIsLoggedIn} />} />

        <Route path="/businesses" element={isLoggedIn ? <BusinessList /> : <Login setIsLoggedIn={setIsLoggedIn} />} />

        <Route path="/gift" element={isLoggedIn ? <GiftList /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/gift_add" element={isLoggedIn ? <AddGift /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/gift_edit" element={isLoggedIn ? <AddGift /> : <Login setIsLoggedIn={setIsLoggedIn} />} />


        <Route path="/greetingcard" element={isLoggedIn ? <GreetingList /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/greetingcard_add" element={isLoggedIn ? <AddGreetingCard /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/greetingcard_edit" element={isLoggedIn ? <AddGreetingCard /> : <Login setIsLoggedIn={setIsLoggedIn} />} />


        <Route path="/category" element={isLoggedIn ? <Category /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/category_add" element={isLoggedIn ? <AddCategory /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/category_edit" element={isLoggedIn ? <AddCategory /> : <Login setIsLoggedIn={setIsLoggedIn} />} />


        <Route path="/ordermanagement" element={isLoggedIn ? <Ordermanagement /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/ordermanagement_view" element={isLoggedIn ? <Ordermanagementview /> : <Login setIsLoggedIn={setIsLoggedIn} />} />

      </Routes>
    </BrowserRouter>
  );
};

// Manage body class changes based on the authentication state
const BodyClassManager = ({ isLoggedIn }) => {
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      document.body.classList.add('login-page');
      document.body.classList.remove('sidebar-mini');
    } else {
      document.body.classList.remove('login-page');
      document.body.classList.add('sidebar-mini');
    }
  }, [location.pathname, isLoggedIn]);

  return null;
};

export default App;
